import { ComponentType, JSX } from 'react';
import { useHistory } from './useHistory';

export const withRouter =
    <P,>(Component: ComponentType<P>): ((props: P) => JSX.Element) =>
    (props: P) => {
        const history = useHistory();
        // eslint-disable-next-line react/jsx-props-no-spreading
        return <Component {...props} history={history} />;
    };
